import loadable from '@loadable/component';

export default loadable(
  () => import(/* webpackChunkName: "coupon-offers" */ './Loadable')
);
